module.exports = __webpack_public_path__ + "static/media/32.76059d84.png";